import { ExtensionsTableCell } from 'app/components/ExtensionsTableCell';
import { CreateScheduleButton } from 'app/components/ListSchedules/components/CreateScheduleButton';
import { QuickFinderGenericDialog } from 'app/components/QuickFinderGenericDialog';
import { useListSchedulesQuery } from 'app/hooks/queries/schedule';
import { parseCallflowNumbers } from 'app/utilities';
import {
  QUERY_SEARCH_INPUT_CHANGED,
  useQueryPaginationReducer,
} from 'app/utilities/useQueryPaginationReducer';
import { startCase } from 'lodash';
import * as React from 'react';
import { useMemo, useState } from 'react';
import { QuickFinderDialogProps } from 'types/components';
import { Schedule } from 'types/schedule';

const QuickFinderScheduleDialog = ({
  onSelect,
  mutationLoading = false,
  mutationLoadingLabel,
  errorMessage,
  onCancel,
  multiple = false,
  initialSelected,
  selectionTitle,
  exclude,
  allowCreate,
}: QuickFinderDialogProps) => {
  // query pagination state
  const [{ queryPageSize, queryPageIndex, querySearchInput }, dispatch] =
    useQueryPaginationReducer(0, 5);

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: (schedule: Schedule) => schedule.doc.name,
      },
    ],
    [],
  );

  // schedule list
  const scheduleListQuery = useListSchedulesQuery(
    queryPageIndex * queryPageSize,
    queryPageSize,
    [['name', 'asc']],
    { searchInput: querySearchInput },
  );
  const { callflows: schedules, totalCount = 0 } = scheduleListQuery.data ?? {};

  const handleSearch = (searchInput: string) => {
    if (searchInput === querySearchInput) {
      scheduleListQuery.refetch();
    } else {
      dispatch({ type: QUERY_SEARCH_INPUT_CHANGED, payload: searchInput });
    }
  };

  const handleCreate = (id: string) => {
    // TODO: does not work with passing resource atm
    onSelect([id]);
  };

  return (
    <QuickFinderGenericDialog
      // dialog
      title={multiple ? 'Select Multiple Schedules' : 'Select Schedule'}
      mutationLoading={mutationLoading}
      mutationLoadingLabel={mutationLoadingLabel}
      onSelect={onSelect}
      onCancel={onCancel}
      errorMessage={errorMessage}
      selectionTitle={selectionTitle}
      titleButton={
        allowCreate ? (
          <CreateScheduleButton
            onComplete={handleCreate}
            // navigateOnComplete={false}
          />
        ) : undefined
      }
      // table
      getRowId={(row: Schedule) => row.id}
      searchPlaceholder={'Search Schedules...'}
      totalCount={totalCount}
      columns={columns}
      data={schedules ?? []}
      multiple={multiple}
      initialSelected={initialSelected}
      exclude={exclude}
      onSearch={handleSearch}
      // query
      queryIsFetching={scheduleListQuery.isFetching}
      queryIsLoading={scheduleListQuery.isLoading}
      queryPageSize={queryPageSize}
      queryPageIndex={queryPageIndex}
      queryPaginationDispatch={dispatch}
    />
  );
};

export default QuickFinderScheduleDialog;
